import {
        eventTypes, statuses,
        createCoordinatesRequested,
        createStatusChanged,
    } from './model';

const makeTransducer =  ({updateLocation, coordinatesToLocation, locationToCoordinates}) => _ => event => {

    if (!event || !event.type)
        return Promise.resolve([]);

    if (event.type === eventTypes.COORDINATES_REQUESTED) {
        updateLocation(coordinatesToLocation(event.data));
        return Promise.resolve([]);
    }

    if (event.type === eventTypes.LOCATION_CHANGED) {
        const maybeCoords = locationToCoordinates(event.data.path);
        if (maybeCoords)
            return Promise.resolve([createCoordinatesRequested(maybeCoords)]);
        else
            return Promise.resolve([createStatusChanged(statuses.NOT_FOUND)]);
    }

    return Promise.resolve([]);

};


export {makeTransducer};



// WEBPACK FOOTER //
// ./src/navigation/transducer.js